module.exports = {
    'common.trademark': '™',
    'common.cancel': 'Cancel',
    'common.ok': 'OK',
    'common.dismiss': 'Dismiss',

    'revisionDetail.copyright': 'Copyright © 2006-2017, Guidewire Software, Inc.',


    'session.warning.title': 'Warning - Automatic Logout',
    'session.warning.message': 'Operator has been inactive for {$1} minutes',
    'session.warning.coundownMessage': 'You will be logged off in {$1}',

    'session.forceLogout.title': 'Warning - Automatic Logout',
    'session.forceLogout.message': 'You have been logged off due to inactivity',

    'login.loginTitle': 'Login',
    'login.forgotPasswordButtonLabel': 'Forgot Password',
    'login.usernameInputLabel': 'Username',
    'login.passwordInputLabel': 'Password',
    'login.confirmPassword': 'Confirm Password',
    'login.loginButtonLabel': 'Login',

    'forgotPassword.forgotPasswordTitle': 'Forgot Password',
    'forgotPassword.sendLinkButtonLabel': 'Send Link',
    'forgotPassword.usernameInputLabel': 'Username',
    'forgotPassword.emailInputLabel': 'Email',
    'forgotPassword.successMessage': 'An email has been sent to you with instructions to reset your password',

    'resetPassword.resetPasswordTitle': 'Change Password',
    'resetPassword.usernameInputLabel': 'Username',
    'resetPassword.oldPasswordInputLabel': 'Old Password',
    'resetPassword.newPasswordInputLabel': 'New Password',
    'resetPassword.verifyNewPasswordInputLabel': 'Verify Password',
    'resetPassword.changePasswordButtonLabel': 'Change Password',
    'resetPassword.verifyPasswordErrorMessage': 'Password verification failed',

    'headerNav.userCenter': 'User Center',
    'headerNav.preferences': 'Preferences',

    'user.enum.userType.1': 'Agency/Brokerage',
    'user.enum.userType.2': 'Service',
    'user.enum.userType.3': 'System',
    'user.enum.userType.4': 'Underwriter',

    'userProfileMenu.aboutOperatorButtonLabel': 'About Operator',
    'userProfileMenu.resetPasswordButtonLabel': 'Reset Password',
    'userProfileMenu.logoutButtonLabel': 'Logout',

    'userCenter.action.forceLogout': 'Force Logout',
    'userCenter.action.broadcast': 'Broadcast Message',

    'userCenter.modal.forceLogoutTitle': 'Force Logout',
    'userCenter.modal.forceLogoutMessage': 'Are you sure that you want to forcefully logout {$1} user{$2}?',
    'userCenter.modal.forceLogoutMessageSuccess': '{$1} Active Session{$2} Successfully Ended',
    'userCenter.modal.broadcastMessageTitle': 'Broadcast Message',
    'userCenter.modal.broadcastMessage': 'Are you sure that you want to broadcast a message to {$1} user{$2}?',
    'userCenter.modal.broadcastMessageSuccess': '{$1} Message{$2} Successfully Sent',

    'userCenter.grid.column.name': 'Name',
    'userCenter.grid.column.username': 'Username',
    'userCenter.grid.column.userType': 'User Type',
    'userCenter.grid.column.clientType': 'Client Type',
    'userCenter.grid.column.systemId': 'Login System',
    'userCenter.grid.column.timeCreated': 'Login Date',
    'userCenter.grid.column.organizationName': 'Organization',

    'userCenter.grid.data.emptyGridDataMessage': 'No matching sessions',

    'userCenter.grid.expandedRow.contactInfoTitle': 'Contact Information',
    'userCenter.grid.expandedRow.address': 'Address:',
    'userCenter.grid.expandedRow.phone': 'Phone:',
    'userCenter.grid.expandedRow.fax': 'Fax:',
    'userCenter.grid.expandedRow.email': 'Email:',
    'userCenter.grid.expandedRow.otherInformationTitle': 'Other Information',
    'userCenter.grid.expandedRow.sessionId': 'Session ID:',

    'userGridFilter.userTypeDropdown.all': 'All',
    'userGridFilter.userTypeDropdown.pleaseSelectLabel': 'Please Select',
    'userGridFilter.refreshListButtonLabel': 'Refresh',
    'userGridFilter.searchPlaceholder': 'Search name or username'
};
